import { classNames } from '../utils/UNSAFE_classNames';
import { StyledComponentProps } from '../utils/UNSAFE_typeUtils';
import { getFormControlClasses } from './FormControlUtils';
import { getTextFieldClasses } from './TextFieldUtils';
import { useFormFieldContext } from '../hooks/UNSAFE_useFormFieldContext';

export type StyleProps = {
  hasInsideLabel?: boolean;
  variant?: 'default' | 'embedded';
};
type Props = StyledComponentProps<'div', StyleProps>;

export const StyledTextField = ({
  hasInsideLabel = false,
  variant = 'default',
  ...props
}: Props) => {
  const { isReadonly } = useFormFieldContext();

  // TODO: We need to re-evaluate how we use CSS multi-classing to our VDOM components
  const formControlClassNames = getFormControlClasses(hasInsideLabel);
  const textFieldClassNames = getTextFieldClasses(isReadonly, variant);
  const cssClassNames = classNames([formControlClassNames, textFieldClassNames]);
  return <div {...props} class={cssClassNames} />;
};
